export default "__VITE_ASSET__DPbVYp8L__"